import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import type PlannedBreakForm from './forms/PlannedBreakForm'

const totalDurationFromUnpaidBreakForms = (breakForms: PlannedBreakForm[]): number => {
  const unpaidBreaks = breakForms.filter(
    (breakForm) =>
      !breakForm.isPaid &&
      ((breakForm.startAt && breakForm.endAt) || breakForm.duration) &&
      breakForm.isValid
  )

  if (!unpaidBreaks) return 0

  return unpaidBreaks.reduce((acc: number, { durationInSeconds }) => acc + durationInSeconds, 0)
}

const totalDurationFromUnpaidBreaks = (plannedBreaks: PlannedBreak[]): number => {
  return plannedBreaks.reduce(
    (acc: number, { isUnpaid, durationInSeconds }) => (isUnpaid ? acc + durationInSeconds : acc),
    0
  )
}

export { totalDurationFromUnpaidBreakForms, totalDurationFromUnpaidBreaks }
